import { useQuery } from "@tanstack/react-query";
import { riskReviewKeys } from "../constants/riskReviewQueryKeys";
import riskReviewService from "../services/riskReviewService";

export const useRiskReviewCreateOptions = () =>
  useQuery({
    queryKey: [...riskReviewKeys.all, "metadata", "create-options"],
    queryFn: riskReviewService.getCreateOptions,
    staleTime: 60000,
  });
